export default {
    "name": "DeleteGroup",
    "kind": "HoudiniMutation",
    "hash": "67ce9728ef741d913580e888b3a9321d9973c8856d9fd7fa2ff8e9b3ef6de53c",

    "raw": `mutation DeleteGroup($deleteGroupId: Int!) {
  deleteGroup(id: $deleteGroupId)
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "deleteGroup": {
                "type": "Int",
                "keyRaw": "deleteGroup(id: $deleteGroupId)",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "deleteGroupId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=1fd1f093701ec9e4ee6b86e123b885530e20ae79aea37f28b3d4317056855d71";